import {useEffect} from 'react';
import {I18n} from '@aws-amplify/core';
import {Stack} from '@mantine/core';
import {PlatformFieldset} from '@pac/platform-ui-components';

import {ProfilesGrid} from '../components/ProfilesGrid';
import {IndexPage as ReturnToComponent} from '../../../features/applications/pages/IndexPage';
import {DisplayUserState} from '../../debug-mode/DisplayUserState';
import {useAccounts} from "../hooks/useAccounts";
import {useAccountActions} from "../hooks/useAccountActions";


export const IndexPage = () => {
    const {accounts, handleFetchAccounts} = useAccounts();
    const {handleContinue, handleSignOut, handleSignOutAndForget, handleHideAccount} = useAccountActions();

    useEffect(() => {
        handleFetchAccounts();
    }, []);


    return (
        <Stack gap="xl">
            <PlatformFieldset legend={I18n.get('Pick an account') + ':'}>
                <ProfilesGrid
                    accounts={accounts}
                    handleContinue={handleContinue}
                    handleSignOut={handleSignOut}
                    handleSignOutAndForget={handleSignOutAndForget}
                    handleHideAccount={handleHideAccount}
                />
            </PlatformFieldset>

            <ReturnToComponent/>

            {<DisplayUserState accounts={accounts} enabled={false}/>}
        </Stack>
    );
};
